import { useFormatter } from '@capsicum/common';

export const useConvertToFiatAndFormat = () => {
	const { formatFiat } = useFormatter();

	return ({
		assetAmount,
		conversionRate,
		fiatShortCode
	}: {
		/** The base amount */
		assetAmount?: number | string;

		/** The conversion rate from 1 of the asset type, to the fiat currency */
		conversionRate?: number | string;

		/** The fiat currency code. Used by the formatter, not for calculation */
		fiatShortCode?: string;
	}): string | undefined => {
		// Since fiat conversions are always estimates, we don't mind the loss of
		// precision from floating-point math
		const converted = Number(assetAmount) * Number(conversionRate);

		if (!fiatShortCode || Number.isNaN(converted)) {
			return;
		}

		return formatFiat(converted, fiatShortCode);
	};
};
